<template>
  <div class="container-fluid">
    <div class="row" style="margin-bottom: 5px; margin-top: -10px;">
      <div class="col offset-10">
        <b-button-group>
          <b-button
            style="font-size: 12px; margin-left: -20px;"
            variant="success"
            @click="exportTable('xlsx')"
            :disabled="report.data == null"
            v-bind:title="exportXlsxReportButton"
          >.XLSX</b-button>
          <b-button
            style="font-size: 12px;"
            variant="success"
            :disabled="true"
            v-bind:title="exportWordReportButton"
          >.DOCX</b-button>
          <b-button
            style="font-size: 12px;"
            variant="success"
            @click="exportTable('xml')"
            :disabled="report.data == null"
            v-bind:title="exportXmlReportButton"
          >.XML</b-button>
        </b-button-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-table
          class="textMiddle"
          small
          hover
          bordered
          show-empty
          responsive
          head-variant="light"
          :items="report.data"
          :fields="headers"
          v-bind:emptyText="$store.state.localization.data.common.table.noData"
          @row-clicked="fuelTankClicked"
          foot-clone
          v-bind:sticky-header="clientHeight"
        >
          <template v-slot:empty="scope">
            <div class="row justify-content-md-center">
              <h5>{{ scope.emptyText }}</h5>
            </div>
          </template>
          <template v-slot:foot()="data">
            <span class="text-success">{{ report.summary[data.column] }}</span>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { fuelTankService, utilsService, userService } from "../../../services";

export default {
  name: "FuelTanksAccountingSystemTable",
  props: {
    fuelTanksInfo: Array,
    fuelTanks: Array,
  },
  computed: {
    exportXlsxReportButton() {
      return this.$store.state.localization.data.mainPage.reports
        .exportXlsxReportButton;
    },
    exportWordReportButton() {
      return this.$store.state.localization.data.mainPage.reports
        .exportWordReportButton;
    },
    exportXmlReportButton() {
      return this.$store.state.localization.data.mainPage.reports
        .exportXmlReportButton;
    },
    headers() {
      const headers = [];
      const disabledHeadersByDefault = ["waterVolume", "waterLevel"];
      const filteredColumns = ["fuelLevel"];

      const displayedColumnsSetting =
        this.$store.state.authentication.userSettings.find((x) => {
          return (
            x.settingName == userService.FUEL_TANKS_TABLE_DISPLAYED_COLUMNS
          );
        });

      headers.push({
          key: "number",
          label: "",
          sortable: false,
          thClass: "textMiddle",
        });

      if (displayedColumnsSetting) {
        const displayedColumns =
          displayedColumnsSetting.settingValue.split(",");

        for (let i = 0; i < displayedColumns.length; i++) {
          if (filteredColumns.includes(displayedColumns[i])) {
            continue;
          }

          headers.push({
            key: displayedColumns[i],
            label:
              this.$store.state.localization.data.mainPage.fuelTanks
                .tableColumns[displayedColumns[i]],
            sortable: true,
            thClass: "textMiddle",
          });
        }
      } else {
        for (let key in this.$store.state.localization.data.mainPage.fuelTanks
          .tableColumns) {
            if (disabledHeadersByDefault.includes(key) || filteredColumns.includes(key)) {
              continue;
            }
          headers.push({
            key: key,
            label:
              this.$store.state.localization.data.mainPage.fuelTanks
                .tableColumns[key],
            sortable: true,
            thClass: "textMiddle",
          });
        }
      }

      return headers;
    },
    clientHeight() {
      const FUEL_TANKS_POSITION_Y = 105;

      return `${
        document.documentElement.clientHeight - FUEL_TANKS_POSITION_Y
      }px`;
    },
    report() {
      const data = [];

      const summary = {
        fuelVolumeTotal: 0,
        fuelVolume: 0,
        fuelVolumeFree: 0,
        fuelVolumePercent: 0,
        fuelWeight: 0,
        fuelTemperature: 0,
        fuelDensity: 0,
        waterVolume: 0,
        fuelLevel: 0,
        fuelVolume15: 0
      };

      if (this.fuelTanksInfo == null || this.fuelTanks == null) {
        return {
          data: data,
          summary: summary,
        };
      }

      let countFuelTanks = 0;

      for (let i = 0; i < this.fuelTanks.length; i++) {
        let row = {
          companyName: this.fuelTanks[i].companyName,
          depoName: this.fuelTanks[i].depoName,
          vehicleId: this.fuelTanks[i].vehicleId,
          fuelTankName: this.fuelTanks[i].fuelTankName,
          fuelType: this.fuelTanks[i].fuelType,
          time: new Date(),
          fuelVolumeTotal: 0,
          fuelVolume: 0,
          fuelVolumeFree: 0,
          fuelVolumePercent: 0,
          fuelWeight: 0,
          fuelTemperature: 0,
          fuelDensity: 0,
          waterVolume: 0,
          fuelLevel: 0,
          fuelVolume15: 0,
        };

        for (let j = 0; j < this.fuelTanksInfo.length; j++) {
          if (this.fuelTanks[i].vehicleId != this.fuelTanksInfo[j].vehicleId) {
            continue;
          }

          const fuelTankInfo = this.fuelTanksInfo[j].fuelTanks.find((item) => {
            return item.fuelTankId == this.fuelTanks[i].fuelTankId;
          });

          if (!fuelTankInfo) {
            continue;
          }

          row.time = new Date(fuelTankInfo.time * 1000);
          row.fuelVolumeTotal = fuelTankInfo.fuelVolumeTotal;
          row.fuelVolume = fuelTankInfo.fuelVolume;
          row.fuelVolumeFree = fuelTankInfo.fuelVolumeFree;
          row.fuelVolumePercent = fuelTankInfo.fuelVolumePercent;
          row.fuelWeight = fuelTankInfo.fuelWeight;
          row.fuelTemperature = fuelTankInfo.fuelTemperature;
          row.fuelDensity = fuelTankInfo.fuelDensity;
          row.waterVolume = fuelTankInfo.waterVolume;
          row.fuelLevel = fuelTankInfo.fuelLevel;
          row.fuelVolume15 = fuelTankInfo.fuelVolume15;
          countFuelTanks++;

          break;
        }

        data.push({
          number: i + 1,
          companyName: row.companyName,
          depoName: row.depoName,
          vehicleId: row.vehicleId,
          fuelTankName: row.fuelTankName,
          fuelType: row.fuelType,
          time: utilsService.formatDateTime(row.time, utilsService.DATE_TIME_FORMAT),
          fuelVolumeTotal: utilsService.formatNumber(row.fuelVolumeTotal, 1),
          fuelVolume: utilsService.formatNumber(row.fuelVolume, 1),
          fuelVolumeFree: utilsService.formatNumber(row.fuelVolumeFree, 1),
          fuelVolumePercent: utilsService.formatNumber(
            row.fuelVolumePercent,
            2
          ),
          fuelWeight: utilsService.formatNumber(row.fuelWeight, 1),
          fuelTemperature: utilsService.formatNumber(row.fuelTemperature, 1),
          fuelDensity: utilsService.formatNumber(row.fuelDensity, 3),
          // waterVolume: utilsService.formatNumber(row.waterVolume, 1),
          fuelLevel: utilsService.formatNumber(row.fuelLevel / 10, 0),
          fuelVolume15: utilsService.formatNumber(row.fuelVolume15, 1),
        });

        summary.fuelVolumeTotal += row.fuelVolumeTotal;
        summary.fuelVolume += row.fuelVolume;
        summary.fuelVolumeFree += row.fuelVolumeFree;
        summary.fuelWeight += row.fuelWeight;
        summary.fuelTemperature += row.fuelTemperature;
        summary.fuelDensity += row.fuelDensity;
        summary.fuelVolume15 += row.fuelVolume15;
        // summary.waterVolume += row.waterVolume;
      }

      summary.fuelVolumePercent = utilsService.formatNumber(
        (100 * summary.fuelVolume) /
          (summary.fuelVolume + summary.fuelVolumeFree),
        2
      );
      summary.fuelVolumeTotal = utilsService.formatNumber(summary.fuelVolumeTotal, 1);
      summary.fuelVolume = utilsService.formatNumber(summary.fuelVolume, 1);
      summary.fuelVolumeFree = utilsService.formatNumber(
        summary.fuelVolumeFree,
        1
      );
      summary.fuelWeight = utilsService.formatNumber(summary.fuelWeight, 1);
      summary.waterVolume = utilsService.formatNumber(summary.waterVolume, 1);

      summary.fuelTemperature = utilsService.formatNumber(
        summary.fuelTemperature / countFuelTanks,
        1
      );
      summary.fuelDensity = utilsService.formatNumber(
        summary.fuelDensity / countFuelTanks,
        3
      );

      summary.fuelVolume15 = utilsService.formatNumber(summary.fuelVolume15, 1);

      return {
        data: data,
        summary: summary,
      };
    },
  },
  methods: {
    fuelTankClicked(record) {
      this.$emit("fuelTankClickedEvent", record.vehicleId);
    },
    async exportTable(format) {
      const normalizedHeaders = [];

      for (let i = 0; i < this.headers.length; i++) {
        normalizedHeaders.push({
          key: this.headers[i].key,
          label: this.headers[i].label
        });
      }

      await fuelTankService.exportFuelTanks(
        format,
        normalizedHeaders,
        "fuelTanks",
        this.report.data,
        this.report.summary
      );
    }
  }
};
</script>

<style>
.textMiddle {
  vertical-align: middle !important;
  text-align: center !important;
  min-width: 20px !important;
}
</style>

